import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { FeedbackRibbon, FeedbackDialogParams, FeedbackCategory } from 'owa-feedback';
import { feedbackSubmitted } from 'owa-search';
import { onFeedbackSubmitted } from 'owa-search-next-lazy';
import sendSearchFeedback from '../helpers/sendSearchFeedback';
import { SubstrateSearchScenario } from 'owa-search-service';
import {
    SearchInContextFeedbackProps,
    UserVoiceSearchTeam,
} from '../components/SearchInContextFeedback';
import { isFeatureEnabled } from 'owa-feature-flags';

const styles = require('./SearchInContextFeedbackDialog.scss');
const classNames = require('classnames');

// this feature can NEVER ship beyond MSIT since it contains PII,
// so we store our strings locally (so that they don't get localized)
const unlocalizedStrings = {
    dialogTitle: 'What issues did you encounter?',
    feedbackCommentsPlaceholder: 'Tell us what happened or how we can improve',
    feedbackLauncherLink: 'Did you find what you were looking for?',
    thankYouMessage: 'Thanks for your feedback!',
    moreFeedback: 'Submit more feedback?',
};

const SearchInlineFeedback = observer(function SearchInlineFeedback(
    props: SearchInContextFeedbackProps
) {
    const feedbackCategories: FeedbackCategory[] = [
        { logString: 'No results were found', uiString: 'No results were found' },
        { logString: 'Search was slow', uiString: 'Search was slow' },
        {
            logString: "The results weren't relevant",
            uiString: "The results weren't relevant",
        },
        {
            logString: "The item I was looking for wasn't in the results",
            uiString: "The item I was looking for wasn't in the results",
        },
        {
            logString: "Search suggestions weren't useful",
            uiString: "Search suggestions weren't useful",
        },
        { logString: 'Search is hard to use', uiString: 'Search is hard to use' },
        { logString: 'Other', uiString: 'Other' },
    ];

    const feedbackDialogParams: FeedbackDialogParams = {
        title: unlocalizedStrings.dialogTitle,
        categories: feedbackCategories,
        ghostText: unlocalizedStrings.feedbackCommentsPlaceholder,
        createUVTicket: true,
        submitCallBack: (
            inlineFeedbackResponse: string,
            inlineFeedbackResponseCategories: string[]
        ) => {
            sendSearchFeedback(
                props.userVoiceTeam,
                inlineFeedbackResponse,
                inlineFeedbackResponseCategories
            );
        },
    };

    const onYesSelected = () => {
        if (isFeatureEnabled('sea-lazy2')) {
            onFeedbackSubmitted(
                props.userVoiceTeam == UserVoiceSearchTeam.MailSearch
                    ? SubstrateSearchScenario.Mail
                    : SubstrateSearchScenario.Calendar,
                true,
                props.currentSearchQueryId,
                unlocalizedStrings.feedbackLauncherLink
            );
        } else {
            feedbackSubmitted(
                props.userVoiceTeam == UserVoiceSearchTeam.MailSearch
                    ? SubstrateSearchScenario.Mail
                    : SubstrateSearchScenario.Calendar,
                true,
                props.currentSearchQueryId,
                unlocalizedStrings.feedbackLauncherLink
            );
        }
    };

    const onNoSelected = () => {
        if (isFeatureEnabled('sea-lazy2')) {
            onFeedbackSubmitted(
                props.userVoiceTeam == UserVoiceSearchTeam.MailSearch
                    ? SubstrateSearchScenario.Mail
                    : SubstrateSearchScenario.Calendar,
                false,
                props.currentSearchQueryId,
                unlocalizedStrings.feedbackLauncherLink
            );
        } else {
            feedbackSubmitted(
                props.userVoiceTeam == UserVoiceSearchTeam.MailSearch
                    ? SubstrateSearchScenario.Mail
                    : SubstrateSearchScenario.Calendar,
                false,
                props.currentSearchQueryId,
                unlocalizedStrings.feedbackLauncherLink
            );
        }
    };

    return (
        <div className={classNames(props.cssClass, styles.inlineRibbonContainer)}>
            <FeedbackRibbon
                ribbonMessage={unlocalizedStrings.feedbackLauncherLink}
                thankYouMessage={unlocalizedStrings.thankYouMessage}
                moreFeedbackRibbonMessage={unlocalizedStrings.moreFeedback}
                feature="Search"
                metadata={props.currentSearchQueryId}
                yesCallBack={onYesSelected}
                noCallBack={onNoSelected}
                noFeedbackDialogParams={feedbackDialogParams}
                yesFeedbackDialogParams={feedbackDialogParams}
            />
        </div>
    );
});

export default SearchInlineFeedback;
